import { uniqueId } from 'lodash';
import React, { useState, useEffect } from 'react';
import { ITooltip, Tooltip } from 'react-tooltip';
import styles from './TooltipTwo.module.scss';

interface TooltipTwoProps extends ITooltip {
    title: React.ReactNode;
    children: React.ReactNode;
}

const TooltipTwo = ({
    title,
    children,
    content,
    ...props
}: TooltipTwoProps) => {
    const id = uniqueId('tooltip-');
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div>
            <a data-tooltip-id={props.id ?? id}>
                {children}
            </a>
            <Tooltip 
                id={props.id ?? id} 
                openOnClick={isMobile} 
                variant='light' 
                style={{
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.5)',
                    border: '1px solid #e0e0e0',
                    borderRadius: '6px',
                    zIndex: 9999,
                    maxHeight: '400px',
                    overflowY: 'auto',
                    pointerEvents: 'auto',
                }} 
                place='bottom' 
                clickable={true}
                delayHide={0}
                events={['hover', 'click']}
                globalCloseEvents={{
                    clickOutsideAnchor: true,
                }}
                {...props}>
                <div className={styles.tooltipContent}>
                    {title}
                </div>
            </Tooltip>
        </div>
    );
};

export default TooltipTwo;
